import { masterClient } from '~/core/utils/clients/masterClient'
import type { CountryCode } from '~/core/i18n/types'

const RESOURCE = '/profile'

export type FinanceDto = {
  totalBalance: number
  totalPromo: number
  hasDebt: boolean
}

export default {
  rulesAgree() {
    return masterClient.patch(`${RESOURCE}/rules/`, {}, { camelize: true })
  },
  recaptchaRequired() {
    return masterClient.get<{ recaptchaRequired: boolean }>(`${RESOURCE}/recaptcha_required/`, { camelize: true })
  },
  captchaRequired(country: CountryCode) {
    return masterClient.get<{ captchaRequired: boolean }>(`${RESOURCE}/captcha_required/`,
      {
        camelize: true,
        params: { country },
      })
  },
  authenticationInfo(payload: {
    phone: string
    gRecaptchaResponse?: string // TODO[sff_use_yandex_captcha]: удалить
    captchaResponse?: string
  }) {
    return masterClient.post<{ onDeletion: boolean }>('/profile/authentication_info/', payload, { camelize: true })
  },
  getFinanceAmount() {
    return masterClient.get<FinanceDto>('/loyalty/finance/amount/', { camelize: true })
  },
}
